import { jwtDecode } from 'jwt-decode'

export function userInfoDecrypted (accessToken) {
  const accessTokenDecoded = jwtDecode(accessToken)

  const userData = {
    aud: accessTokenDecoded?.aud,
    exp: accessTokenDecoded?.exp,
    iss: accessTokenDecoded?.iss,
    jti: accessTokenDecoded?.jti,
    data: JSON.parse(accessTokenDecoded?.['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'])
  }

  return userData
}

export function truncatedAccessToken (accessToken, trucLength) {
  const tokenLength = accessToken?.length
  const truncatedAccessToken_ = accessToken.slice(0, (parseInt(tokenLength) - parseInt(trucLength)))

  return truncatedAccessToken_
}
